module.exports = {
  messages: {
    CRATE_LEBENSLAUF_TEMPLATES_COVER_LETTER_AI_BANNER:
      'Dieser Entwurf stammt von der KI. Bitte bearbeite ihn und verleih ihm Deine eigene Note.',
    CRATE_LEBENSLAUF_TEMPLATES_COVER_LETTER_AI_FEEDBACK:
      'Hat Dir das geholfen?',
    CRATE_VITA_PREVIEW_PAGINATION_LEFT: 'Vorherige Seite',
    CRATE_VITA_PREVIEW_PAGINATION_RIGHT: 'Nächste Seite',
    CRATE_VITA_PREVIEW_PRESENT: 'Heute',
    CRATE_VITA_TEMPLATE_COVER_LETTER_TAG: 'Anschreiben',
    CRATE_VITA_TEMPLATE_PAGE_NUMBER: 'Seite {pageIndex}',
    CRATE_VITA_TEMPLATE_TAG: 'Lebenslauf',
    CRATE_VITA_TEMPLATES_ABOUT_ME_TITLE: 'Über mich',
    CRATE_VITA_TEMPLATES_EDUCATION_TITLE: 'Ausbildung',
    CRATE_VITA_TEMPLATES_LABEL_ADDRESS: 'Anschrift',
    CRATE_VITA_TEMPLATES_LABEL_BIRTH: 'geb.',
    CRATE_VITA_TEMPLATES_LABEL_COUNTRY: 'Land',
    CRATE_VITA_TEMPLATES_LABEL_EMAIL: 'E-Mail',
    CRATE_VITA_TEMPLATES_LABEL_PHONE: 'Tel.',
    CRATE_VITA_TEMPLATES_PERSONAL_TITLE: 'Persönliche Infos',
    CRATE_VITA_TEMPLATES_PROFESSIONAL_TITLE: 'Erfahrung',
    CRATE_VITA_TEMPLATES_SKILLS_TITLE: 'Fähigkeiten',
  },
};
